
import { ExternalLink } from '@uikit';

import { Calendar } from '@uikit/icons/Calendar';
import { Checked3 } from '@uikit/icons/Checked3';
import { Cup } from '@uikit/icons/Cup';
import { DollarCoin } from '@uikit/icons/DollarCoin';

export const team = [
  {
    name: 'Borja Burguillos',
    position: 'Founding Partner & CEO',
    description: (
      <>
        Over 18 years in building tech products, marketing, and strategic development within the fan
        engagement and gaming industry.{' '}
        <ExternalLink
          className="story-prose-link"
          href="https://www.linkedin.com/in/borjaburguillos"
        >
          LinkedIn
        </ExternalLink>
      </>
    ),
    avatar: '/store/stories/5tars/5tars-story-team-borja-burguillos.png',
  },
  {
    name: 'Ivan Campillo',
    position: 'Founding Partner & CTO',
    description: (
      <>
        20 years of expertise in software development, specializing in blockchain and gaming
        technologies.{' '}
        <ExternalLink
          className="story-prose-link"
          href="https://www.linkedin.com/in/ivan-campillo-sw"
        >
          LinkedIn
        </ExternalLink>
      </>
    ),
    avatar: '/store/stories/5tars/5tars-story-team-ivan.png',
  },
  {
    name: 'Alvaro Cid',
    position: 'Blockchain Lead',
    description: (
      <>
        12 years in developing secure, scalable blockchain systems and deploying high-stakes
        financial applications on Ethereum and other platforms.{' '}
        <ExternalLink
          className="story-prose-link"
          href="https://www.linkedin.com/in/alvaro-cid-rodriguez"
        >
          LinkedIn
        </ExternalLink>
      </>
    ),
    avatar: '/store/stories/5tars/5tars-story-team-alvaro.png',
  },
  {
    name: 'Borja Puado',
    position: 'Head of Marketing and Growth',
    description: (
      <>
        Over 10 years of extensive experience in Web3 user acquisition projects, driving user growth
        and brand visibility to ensure robust market penetration for the platform.{' '}
        <ExternalLink className="story-prose-link" href="https://www.linkedin.com/in/borjagpuado">
          LinkedIn
        </ExternalLink>
      </>
    ),
    avatar: '/store/stories/5tars/5tars-story-team-borja-puado.png',
  },
];

export const FIVE_TARS_STORY_URLS = {
  campaign: 'https://zealy.io/cw/5tars-road-to-ido-magic-square/',
};

export const stats = [
  {
    name: 'Prize Pool',
    stat: '$250,000 in 5TARS Token Rewards',
    Icon: Cup,
  },
  {
    name: 'Campaign Duration',
    stat: '12th of June - After the 5TARS IDO',
    Icon: Calendar,
  },
  {
    name: 'Reward Vesting',
    stat: '10% at TGE, 3 months cliff, 6 months vesting',
    Icon: DollarCoin,
  },
  {
    name: 'Tasks and Participation',
    Icon: Checked3,
    stat: (
      <ul className="md:text-2xl pl-[1.5em] list-disc">
        <li>Complete tasks, collect XP, rewards distribution by 5TARS.io after their TGE</li>
        <li>Tasks will include Social Media, Content, and activity in the 5TARS Ecosystem</li>
      </ul>
    ),
  },
];

export const partners = [
  {
    name: 'SEIER CAPITAL',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-seier-capital.png',
    },
  },
  {
    name: 'FLAT6LABS',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-flat6labs.png',
    },
  },
  {
    name: 'KAIRON LABS',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-kairon-labs.png',
    },
  },
  {
    name: 'CONCORDIUM',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-concordium.png',
    },
  },
  {
    name: 'SKALE',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-skale.png',
    },
  },
  {
    name: 'brinc',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-brinc.png',
    },
  },
  {
    name: 'KGEN',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-kgen.png',
    },
  },
  {
    name: 'HACKEN',
    image: {
      url: '/store/stories/5tars/5tars-story-partners-hachen.png',
    },
  },
];
